// id strings for messages/studioOptions.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studioOptions: Dict = {
  "studioOptions.pitch.title": "Pitch",
  "studioOptions.pitch.hint":
    "Dalam semitone. Dari suara cowok ke suara cewek? Coba +12.",
  "studioOptions.pitch.label": "pitch untuk {name}",
  "studioOptions.pitch.maleToFemale": "Cowok → cewek",
  "studioOptions.pitch.femaleToMale": "Cewek → cowok",
  "studioOptions.pitch.original": "Asli",
  "studioOptions.stepper.lower": "Turunkan {label}",
  "studioOptions.stepper.raise": "Naikkan {label}",
  "studioOptions.effect.title": "Efek",
  "studioOptions.effect.hint": "Satu per satu. Ketuk lagi untuk menghapusnya.",
  "studioOptions.effect.none": "Tanpa efek",
  "studioOptions.effect.onVocals": "Di vokal",
  "studioOptions.effect.onSong": "Di seluruh lagu",
  "studioOptions.autotune.title": "Autotune",
  "studioOptions.autotune.switch": "Sesuaikan vokal ke kunci nada",
  "studioOptions.autotune.hint":
    "Dari polesan halus sampai suara robot yang kentara.",
  "studioOptions.autotune.light": "Ringan",
  "studioOptions.autotune.medium": "Sedang",
  "studioOptions.autotune.strong": "Kuat",
  "studioOptions.mix.title": "Mix",
  "studioOptions.mix.vocalVolume": "Volume vokal",
  "studioOptions.mix.vocalVolumeHint":
    "Lebih keras atau lebih pelan dari musiknya, dalam dB.",
  "studioOptions.mix.vocalVolumeLabel": "volume vokal",
  "studioOptions.mix.backing": "Pisahkan backing vocal",
  "studioOptions.mix.backingHint":
    "Hasil lebih bersih kalau lagunya punya harmoni atau ad-lib.",
  "studioOptions.mix.vocalsOnly": "Audioku cuma vokal",
  "studioOptions.mix.vocalsOnlyHint": "Lewati pemisahan vokal dari musik.",
  "studioOptions.name.title": "Nama cover",
  "studioOptions.name.placeholder": "Opsional",

  "studioOptions.summary.pitch": "Pitch {values}",
  "studioOptions.summary.autotune": "Autotune",
  "studioOptions.summary.vocals": "Vokal {value}",
  "studioOptions.summary.backing": "Backing vocal dipisah",
  "studioOptions.summary.vocalsOnly": "Input cuma vokal",
  "studioOptions.summary.default": "Pitch asli, tanpa efek",

  "studioOptions.video.previewAria": "Pratinjau Marble Run",
  "studioOptions.video.headline":
    "Suara-suaramu balapan. Yang memimpin, dia yang nyanyi.",
  "studioOptions.video.body":
    "Setiap ganti pemimpin, suaranya ikut ganti, dengan lirik di layar. Siap diposting di TikTok dan Reels.",
  "studioOptions.video.crown": "Mahkota menunjukkan siapa yang sedang nyanyi",
  "studioOptions.video.pickLook": "Pilih tampilan",
  "studioOptions.video.customise": "Kustomisasi",
  "studioOptions.video.surprise": "Kejutkan aku",
  "studioOptions.video.marbles": "Kelereng dan lintasan",
  "studioOptions.video.sky": "Langit",
  "studioOptions.video.font": "Font lirik",
  "studioOptions.video.stars": "Bintang di langit",
  "studioOptions.theme.midnight": "Tengah Malam",
  "studioOptions.theme.neon": "Neon",
  "studioOptions.theme.ocean": "Samudra",
  "studioOptions.theme.royal": "Royal",
  "studioOptions.theme.lava": "Lava",
  "studioOptions.theme.gold": "Emas",

  "studioOptions.upload.empty": "File ini kosong. Pilih file lagunya lagi, ya.",
  "studioOptions.upload.tooBig":
    "Ukuran file lebih dari 75MB! Unggah file yang lebih kecil.",
  "studioOptions.upload.tooLong":
    "Durasi audio lebih dari 6 menit! Unggah file yang lebih pendek.",
  "studioOptions.upload.invalid": "Unggah file audio yang valid",
  "studioOptions.upload.unexpected": "Terjadi kesalahan yang tidak terduga.",
  "studioOptions.upload.uploading": "Mengunggah...",
  "studioOptions.upload.coverAlt": "cover",
  "studioOptions.upload.dropIt": "Lepaskan di sini",
  "studioOptions.upload.dropHere": "Taruh audiomu di sini",
  "studioOptions.upload.browse": "Pilih file",
  "studioOptions.upload.formats": "MP3, WAV atau M4A · maksimal 6 menit",
  "studioOptions.upload.dropOrBrowse":
    "Taruh file audio di sini atau klik untuk memilih",
  "studioOptions.upload.limits": "Maks 75MB, 6 menit • MP3, WAV, M4A",

  "studioOptions.mic.denied":
    "Izinkan akses mikrofon di browser kamu untuk merekam.",
  "studioOptions.mic.notFound": "Mikrofon untuk merekam tidak ditemukan.",
  "studioOptions.mic.prepareFailed": "Gagal menyiapkan lokasi unggahan.",
  "studioOptions.mic.fileFailed": "Gagal mengunggah file.",
  "studioOptions.mic.uploadFailed": "Unggahan rekaman mikrofon gagal.",
  "studioOptions.mic.previewFailed": "Pratinjau audio tidak bisa diputar.",
  "studioOptions.mic.start": "Mulai merekam",
  "studioOptions.mic.stop": "Berhenti merekam",
  "studioOptions.mic.tapRecord": "Ketuk untuk merekam",
  "studioOptions.mic.tapStop": "Ketuk untuk berhenti",
  "studioOptions.mic.clickRecord": "Klik untuk merekam",
  "studioOptions.mic.processing": "Memproses...",
  "studioOptions.mic.playPreview": "Putar pratinjau",
  "studioOptions.mic.pausePreview": "Jeda pratinjau",
  "studioOptions.mic.yourRecording": "Rekamanmu",
  "studioOptions.mic.use": "Pakai rekaman ini",
  "studioOptions.mic.again": "Rekam lagi",
  "studioOptions.mic.continue": "Lanjut",
};

export default studioOptions;
